export enum EClientPlatform {
	IOS = 'ios',
	ANDROID = 'android',
}